import type { ValidatedToolResponse } from '@seen/core/models/validatedToolResponse'
import type { JSX } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router'
import { ValidatedToolForm } from '#src/components/validated-tool-form/ValidatedToolForm.tsx'
import { useCreateMutation } from '#src/hooks/useCreateMutation.ts'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

export function ValidatedToolPage(): JSX.Element {
  const { validatedToolName, patientId } = useParams()
  const navigate = useNavigate()
  const isReadOnly = useIsReadOnly()
  const createMutation = useCreateMutation<ValidatedToolResponse>()

  if (isReadOnly) {
    return <Navigate to=".." replace />
  }

  return (
    <ValidatedToolForm
      name={validatedToolName}
      onSubmit={(response, form) => {
        createMutation.mutate(response, { onSuccess: () => form.reset() })
        void navigate(-1)
      }}
      className="pb-16"
      restorationId={`${patientId}-${validatedToolName}`}
    />
  )
}
